import * as yup from 'yup';

import i18n from '../../../../i18n/configs';

const requiredValidation = yup
  .string()
  .required(i18n.t('validation.error.required'));

const imageValidation = yup
  .mixed()
  .test('type', i18n.t('validation.error.image'), (value: FileList): boolean =>
    value
      ? String(value).includes('.jpg') ||
        String(value).includes('.jpeg') ||
        String(value).includes('.png') ||
        String(value).includes('.webp') ||
        String(value).includes('.gif') ||
        String(value).includes('.svg') ||
        String(value).includes('.JPG') ||
        String(value).includes('.JPEG') ||
        String(value).includes('.PNG') ||
        String(value).includes('.WEBP') ||
        String(value).includes('.GIF') ||
        String(value).includes('.SVG')
      : true
  );

export const articleSchema = yup.object().shape({
  bgImg: imageValidation,
  caseStudy: yup.string(),
  feature: yup.string(),
  media: yup
    .string()
    .transform((value, originalValue) =>
      originalValue ? String(originalValue) : undefined
    )
    .test(
      'is-selected',
      i18n.t('validation.error.required'),
      (value) => value !== undefined && value !== ''
    )
    .required(i18n.t('validation.error.required')),
  menu: yup.string(),
  message: yup.string(),
  outline: yup.string(),
  title: requiredValidation
    .nullable()
    .max(250, i18n.t('validation.error.below250'))
});
